import { connect } from 'react-redux';
import { getUserName } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { getSessionStorage } from '@tcp/core/src/utils/utils.web';
import { getRtpsModalThreshold } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import GlobalRtpsModal from '../views/GlobalRtpsModal.view';
import { getIsRtpsModalOpen, getIsRtpsFlow } from './GlobalRtpsModal.selector';
import { toggleApplyNowModal } from '../../ApplyNowPLCCModal/container/ApplyNowModal.actions';
import { resetPLCCResponse } from '../../../../features/browse/ApplyCardPage/container/ApplyCard.actions';
import {
  submitAcceptOrDeclinePlccOffer,
  setIsRTPSFlow,
} from '../../../../features/CnC/Checkout/container/Checkout.action.util';

export const mapStateToProps = (state) => {
  const rtpsModalTimeStamp = getSessionStorage('rtpsModalTimeStamp') || '';
  const rtpsModalThreshold = getRtpsModalThreshold(state);
  const isRtpsModalEnabled = getIsRtpsModalOpen(state);
  const isRtpsModalOpen =
    isRtpsModalEnabled && Date.now() - rtpsModalTimeStamp > rtpsModalThreshold;
  return {
    isRtpsModalOpen,
    firstName: getUserName(state),
    isRtpsFlow: getIsRtpsFlow(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    toggleRtpsModal: (payload) => {
      dispatch(toggleApplyNowModal(payload));
    },
    resetPLCCApplicationStatus: (payload) => {
      dispatch(resetPLCCResponse(payload));
    },
    submitAcceptOrDeclinePlcc: (payload) => {
      dispatch(submitAcceptOrDeclinePlccOffer(payload));
    },
    setIsRTPSFlowActn: (payload) => {
      dispatch(setIsRTPSFlow(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalRtpsModal);
